import { HTMLSpocUIProps, Orientation, PropGetter } from "@/types";
import { Ref, useCallback, useMemo } from "react";
import { timelineClasses, TimelineVariantProps } from "./Timeline.style";

interface Props extends HTMLSpocUIProps<"ol"> {
  /**
   * Ref to the DOM node.
   */
  ref?: Ref<HTMLElement> | undefined;
  /**
   * The orientation of the separator.
   * @default 'horizontal'
   */
  orientation?: Orientation;
}

export type TimelineProps = Props &
  Omit<TimelineVariantProps, "orientation"> & {
    isConnected?: boolean;
  };

export const useTimeline = (props: TimelineProps) => {
  const { className, orientation, variant, isConnected, ...otherProps } = props;

  const styles = useMemo(
    () =>
      timelineClasses({
        orientation,
        variant,
        className,
      }),
    [orientation, variant, className]
  );

  const getTimelineProps: PropGetter = useCallback(
    (props = {}) => ({
      className: styles,
      role: "timeline",
      "data-orientation": orientation,
      isConnected,
      variant,
      ...otherProps,
      ...props,
    }),
    [styles, orientation, variant, otherProps]
  );
  return { getTimelineProps };
};

export type TimelineReturn = ReturnType<typeof useTimeline>;
